import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";

export const useGantiProduksi = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [dataDowntime, setDataDowntime] = useState();
  const [filterMonth, setFilterMonth] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterYear, setFilterYear] = useState(
    moment().utcOffset("+0700").year()
  );
  const [produkPick, setProdukPick] = useState();
  const [bagianPick, setBagianPick] = useState();

  const [jenisPick, setJenisPick] = useState("Pilih Jenis");

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getDowntimeGantiProduksi`,
      {
        filterDate: `${filterYear}-${("0" + filterMonth).slice(-2)}`,
        filterYear: filterYear.toString(),
        filterProduk: produkPick,
        tim: dataUser.tim,
      },
      dataUser.auth,
      setDataDowntime,
      ""
    );
  }, [filterMonth, filterYear]);

  let listGantiMold = [];

  dataDowntime &&
    dataDowntime.listGantiMold.forEach((element) => {
      element &&
        element.utama.forEach((e) => {
          listGantiMold.push({
            customer: e.customer,
            color: e.color,
            id: e.id,
            mesin: e.mesin,
            moldProduk: e.moldProduk,
            jenis: e.jenis,
          });
        });
    });

  let reStructureMold = [];
  let reStructureProduksi = [];

  dataDowntime &&
    dataDowntime.dataGantiProduksi.map((user) => {
      if (user.qrMold) {
        let preference =
          listGantiMold &&
          listGantiMold.find((pref) => pref.id === user.qrMold);

        if (preference && preference.id) {
          reStructureMold.push({ ...preference, ...user });
        }
      } else {
        let preference =
          listGantiMold &&
          listGantiMold.find((pref) => pref.id === user.qrProduksi);

        if (preference && preference.id) {
          reStructureProduksi.push({ ...preference, ...user });
        }
      }
    });

  let mergeObject = [...reStructureMold, ...reStructureProduksi];

  let listSelectProduk = [];

  mergeObject &&
    mergeObject.forEach((element) => {
      let find =
        listSelectProduk &&
        listSelectProduk.find((pref) => pref.value === element.moldProduk);

      if (!find) {
        listSelectProduk.push({
          value: element.moldProduk,
          label: `${element.moldProduk} - ${element.color}`,
        });
      }
    });

  const handleReset = () => {
    setProdukPick();
    setBagianPick();
    setJenisPick("Pilih Jenis");
  };

  const searchFeature = (params) => {
    if (produkPick && !bagianPick) {
      let searchName = [];
      mergeObject &&
        mergeObject.forEach((value) => {
          if (value.moldProduk === params.value) {
            searchName.push(value);
          }
        });
      return searchName;
    } else if (produkPick && bagianPick === "Mold") {
      let searchName = [];

      mergeObject &&
        mergeObject.forEach((value) => {
          if (value.moldProduk === params.value && value.qrMold) {
            searchName.push(value);
          }
        });
      return searchName;
    } else if (produkPick && bagianPick === "Produksi") {
      let searchName = [];

      mergeObject &&
        mergeObject.forEach((value) => {
          if (value.moldProduk === params.value && value.qrProduksi) {
            searchName.push(value);
          }
        });
      return searchName;
    } else if (!produkPick && bagianPick === "Mold") {
      let searchName = [];

      mergeObject &&
        mergeObject.forEach((value) => {
          if (value.qrMold) {
            searchName.push(value);
          }
        });
      return searchName;
    } else if (!produkPick && bagianPick === "Produksi") {
      let searchName = [];

      mergeObject &&
        mergeObject.forEach((value) => {
          if (value.qrProduksi) {
            searchName.push(value);
          }
        });
      return searchName;
    } else if (jenisPick !== "Pilih Jenis") {
      let searchName = [];
      mergeObject &&
        mergeObject.forEach((value) => {
          if (value.jenis === jenisPick) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return mergeObject && mergeObject;
    }
  };
  let dataTemp = searchFeature(produkPick);

  // const filterProduk = () => {
  //   if (produkPick) {
  //     let searchName = [];
  //     dataDowntime &&
  //       dataDowntime.dataGantiProduksi.forEach((value) => {
  //         if (value.produk === produkPick.value) {
  //           searchName.push(value);
  //         }
  //       });
  //     return searchName;
  //   } else {
  //     return dataDowntime && dataDowntime.dataGantiProduksi;
  //   }
  // };
  // let dataTempFilterProduk = filterProduk(produkPick);
  // console.log(dataTempFilterProduk);

  let listJenis = [];

  listGantiMold &&
    listGantiMold.forEach((element) => {
      const nameMatches = listJenis.includes(element.jenis);

      if (!nameMatches) {
        listJenis.push(element.jenis);
      }
    });

  return {
    dataUser,
    filterYear,
    setFilterYear,
    filterMonth,
    setFilterMonth,
    listSelectProduk,
    produkPick,
    setProdukPick,
    handleReset,
    dataTemp,
    bagianPick,
    setBagianPick,

    jenisPick,
    setJenisPick,
    listJenis,
  };
};
